import { Component, OnInit } from '@angular/core';
import { AppMessage } from '../model/messages.model';

@Component({
    selector: 'app-allo-extracts',
    templateUrl: './allo-extracts.component.html',
    styleUrls: ['./allo-extracts.component.css'],
    standalone: false // NOSONAR
})
export class AlloExtractsComponent implements OnInit {

  errMsgs: AppMessage[];
  activeTab: string = 'alloProperties';

  constructor() { }

  ngOnInit() { // NOSONAR 
  }

  setActiveTab(tabName: string): void {
    this.activeTab = tabName;    
    this.errMsgs = [];
  }
  
}
